import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["selectAll", "item", "toolbar", "count", "status", "priority", "apply", "error"];
  static values = { updateUrl: String, deleteUrl: String };

  connect() {
    this.update();
  }

  get selectedIds() {
    return this.itemTargets.filter((item) => item.checked).map((item) => item.value);
  }

  toggleAll() {
    this.itemTargets.forEach((item) => { item.checked = this.selectAllTarget.checked; });
    this.update();
  }

  update() {
    const selectedCount = this.selectedIds.length;
    if (this.hasToolbarTarget) this.toolbarTarget.style.display = selectedCount ? "" : "none";
    if (this.hasCountTarget) this.countTarget.textContent = selectedCount;
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = this.itemTargets.length > 0 && selectedCount === this.itemTargets.length;
      this.selectAllTarget.indeterminate = selectedCount > 0 && selectedCount < this.itemTargets.length;
    }
    if (this.hasApplyTarget) {
      this.applyTarget.disabled = selectedCount === 0 || (!this.statusTarget.value && !this.priorityTarget.value);
    }
    if (this.hasErrorTarget) this.errorTarget.hidden = true;
  }

  clear() {
    this.itemTargets.forEach((item) => { item.checked = false; });
    this.update();
  }

  async apply() {
    if (!this.selectedIds.length || (!this.statusTarget.value && !this.priorityTarget.value)) return;
    if (!window.confirm(`确定更新选中的 ${this.selectedIds.length} 个工程？`)) return;
    const changes = {};
    if (this.statusTarget.value) changes.status = this.statusTarget.value;
    if (this.priorityTarget.value) changes.priority = this.priorityTarget.value;
    await this.submit(this.updateUrlValue, "PATCH", changes);
  }

  async delete() {
    if (!this.selectedIds.length) return;
    if (!window.confirm(`确定删除选中的 ${this.selectedIds.length} 个工程？此操作不可撤销。`)) return;
    await this.submit(this.deleteUrlValue, "DELETE");
  }

  async submit(url, method, changes = {}) {
    const body = new FormData();
    body.append("earthwork_ids", this.selectedIds.join(","));
    Object.entries(changes).forEach(([key, value]) => body.append(key, value));
    const token = document.querySelector('meta[name="csrf-token"]')?.content;

    try {
      const response = await fetch(url, {
        method,
        body,
        headers: { "Accept": "application/json", "X-CSRF-Token": token || "" }
      });
      const result = await response.json();
      if (!response.ok || !result.success) throw new Error(result.error || "操作失败，请重试");
      window.location.reload();
    } catch (error) {
      if (this.hasErrorTarget) {
        this.errorTarget.textContent = error.message;
        this.errorTarget.hidden = false;
      }
    }
  }
}
